"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EAutreCgpGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EAutreCgpGroups");
const EPatrimoineRevenusGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EPatrimoineRevenusGroups");
const GenericProduct_1 = require("../GenericProduct");
const EPaymentMethod_1 = require("../../../../enums/ProductSubscribed/EPaymentMethod");
const ESubFilesTypes_1 = require("../../../../enums/Subscription/File/ESubFilesTypes");
const EConnaissanceExprerienceGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EConnaissanceExprerienceGroups");
const ETestAdequationGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/ETestAdequationGroups");
const product = {
    payment_methods: {
        groups: [EPaymentMethod_1.EPaymentMethod.CHEQUE, EPaymentMethod_1.EPaymentMethod.VIREMENT, EPaymentMethod_1.EPaymentMethod.PRELEVEMENT, EPaymentMethod_1.EPaymentMethod.CREDIT, EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM],
        validationClass: GenericProduct_1.GenericProduct.payment_methods.validationClass,
    },
    patrimoine_revenus: {
        groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.patrimoine, EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenusAnnuelsBrutsFoyer, EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.compositionRevenus],
        validationClass: GenericProduct_1.GenericProduct.patrimoine_revenus.validationClass,
    },
    connaissance_experience: {
        groups: [
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.supportPlacement,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.dejaSouscritScpi,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.dejaSouscritScpiPartPierval,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.dejaSouscritScpiNamePierval,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.nbSouscriptionsScpi,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.datePremiereSouscription,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.dateDerniereSouscription,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.experienceProfessionnelle,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.modeGestionUtilise,
            EConnaissanceExprerienceGroups_1.EConnaissanceExprerienceGroups.nbOperationsDerniersMois,
        ],
        validationClass: GenericProduct_1.GenericProduct.connaissance_experience.validationClass,
    },
    test_adequation: {
        groups: [
            ETestAdequationGroups_1.ETestAdequationGroups.modalitesAchatPartsSCPI,
            ETestAdequationGroups_1.ETestAdequationGroups.modalitesVentePartsSCPI,
            ETestAdequationGroups_1.ETestAdequationGroups.accepterRendementNonGaranti,
            ETestAdequationGroups_1.ETestAdequationGroups.fiscaliteApplicableScpi,
        ],
        validationClass: GenericProduct_1.GenericProduct.test_adequation.validationClass,
    },
    finance_durable: GenericProduct_1.GenericProduct.finance_durable,
    autre_cgp: {
        groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationClient, EAutreCgpGroups_1.EAutreCgpGroups.appreciationOperation],
        validationClass: GenericProduct_1.GenericProduct.autre_cgp.validationClass,
    },
    files: {
        groups: [ESubFilesTypes_1.ESubFilesTypes.CART_ID, ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_DOMICILE, ESubFilesTypes_1.ESubFilesTypes.JUSTIFICATIF_ORIGINE_FONDS, ESubFilesTypes_1.ESubFilesTypes.RIB],
        validationClass: GenericProduct_1.GenericProduct.files.validationClass,
    },
};
exports.default = product;
